// apps/frontend/src/services/chatService.js
import api from './api';

/**
 * Header del token della conversazione (card #10434653609): le rotte pubbliche della
 * chat lo pretendono su ogni chiamata che porta un conversationId.
 */
export function conversationTokenHeaders(conversationToken) {
  return { headers: conversationToken ? { 'X-Conversation-Token': conversationToken } : {} };
}

/**
 * Open-panel handshake. Creates (or, with its token, re-opens) the conversation and
 * returns its id plus the ordered messages. A new conversation also returns
 * `conversationToken`: keep it, every later call needs it.
 * Returns { success, conversationId, messages, conversationToken? }.
 */
export async function initConversation({ botId, conversationId, conversationToken, initLanguage } = {}) {
  if (!botId) throw new Error('botId is required');
  const response = await api.post('/chat/init', {
    botId,
    conversationId: conversationId || undefined,
    initLanguage: initLanguage || undefined
  }, conversationTokenHeaders(conversationToken));
  return response.data;
}

export default { initConversation, conversationTokenHeaders };
